/**
 * Feedback Service
 * Handles feedback-related database operations
 */

import { BaseService } from './BaseService.js'
import { COLLECTIONS } from '../config.js'

export class FeedbackService extends BaseService {
  constructor() {
    super(COLLECTIONS.FEEDBACK)
  }
}

export const feedbackService = new FeedbackService()
